export default __webpack_public_path__ + "static/media/gt.a208122c.svg";